import React from 'react';

/**
 * Modal prompt for restoring a version with optional note
 */
const RestorePrompt = ({
  versionNumber,
  note,
  onNoteChange,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="preview-panel__restore-prompt">
      <div className="preview-panel__restore-prompt-backdrop" onClick={onCancel} />
      <div className="preview-panel__restore-prompt-content">
        <h3>Restore Version {versionNumber}?</h3>
        <p>This will create a new version from the selected older version.</p>
        <label>
          Add a note (optional):
          <textarea
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
            placeholder="e.g., Reverting to previous design..."
            rows={3}
            autoFocus
          />
        </label>
        <div className="preview-panel__restore-prompt-actions">
          <button 
            className="preview-panel__restore-prompt-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="preview-panel__restore-prompt-confirm"
            onClick={onConfirm}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
            </svg>
            Restore Version
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestorePrompt;
